import { SSORegister } from '@/components/auth/SSORegister';

export default function SSORegisterPage() {
  return <SSORegister />;
}

